import Request from './request';

// 获取页面模块数据
function getPageCompsData(pageId) {
  return new Promise((resolve, reject) => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-table/lego/data?uuid=schema-1a31b3fb-52a6-5d33-9999-095ee40e60d2',
      method: 'post',
      withCredentials: true,
      data: {
        option: {
          orders: [],
          filters: {
            $and: [{ "日期": { "$eq": 20251027 }}]
          }
        }
      }
    }).then((res) => {
      const { status, data = {} } = res.data;
      if (status === 0 && data && data.list && data.list.length > 0) {
        const target = data.list.find(item => item['乐高id'] === pageId);
        resolve(target);
      } else {
        resolve(null);
      }
    }).catch((err) => {
      reject(err);
    });
  });
}

// 计算模块点击率，并返回指定TopN的模块信息
async function getTopNComponents(pageId, TopN) {
  const pageData = await getPageCompsData(pageId);
  let compsClickExposeData = [];
  if (pageData) {
    let { '组装好的数据': moduleData = [] } = pageData;
    moduleData = JSON.parse(moduleData);
    for (const key in moduleData.component) {
      if (Object.prototype.hasOwnProperty.call(moduleData.component, key)) {
        const element = moduleData.component[key];
        const temp = {
          component_id: element.component_id,
          click_expose_rate: ((element.clk_pv / element.exp_pv).toFixed(3))
        }
        compsClickExposeData.push(temp);
      }
    }
    // 将组件的点爆数据按照点击率从高到低排序，并返回TopN
    compsClickExposeData = compsClickExposeData.sort((a, b) => b.click_expose_rate - a.click_expose_rate).splice(0, TopN);
  }
  return compsClickExposeData;
}

// 页面干预逻辑
export async function interveneTest(pipelineComponents, pageId, group) {
  if (pageId === '17538544856470097') {
    // 北面品牌馆
    if (group === 'Group_3') {
      // 实验组A，Tab排序随机打散
      const pipelineTabIdx = pipelineComponents.findIndex(item => item.name === 'pipeline-tab');
      const pipelineTab = pipelineComponents.find(item => item.name === 'pipeline-tab');
      const pipelineTabItems = pipelineComponents.filter(item => item.name === 'pipeline-tabItem');
      const randomTabs = pipelineTab.data.containerConfig.grains.filter(item => ['冲锋衣/夹克', '羽绒服', '防晒衣/皮肤衣', '裤装'].includes(item.tabTitle.tabName)) || [];
      const unRandomTabs = pipelineTab.data.containerConfig.grains.filter(item => !['冲锋衣/夹克', '羽绒服', '防晒衣/皮肤衣', '裤装'].includes(item.tabTitle.tabName)) || [];

      // randomTabs进行随机排序
      for (let i = randomTabs.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = randomTabs[i];
        randomTabs[i] = randomTabs[j];
        randomTabs[j] = tmp;
      }

      // 先过滤掉所有的pipeline-tabItem
      let compUnIncludeTabItems = pipelineComponents.filter(item => item.name !== 'pipeline-tabItem');

      for (let i = 0; i < randomTabs.length; i++) {
        // 根据重新排序后的randomTabs，找到对应的pipeline-tabItem；再将pipeline-tabItem按照重排后的顺序插入到compUnIncludeTabItems中
        const tabItemName = randomTabs[i].tabTitle.tabName;
        const tabItemTargetComp = pipelineTabItems.find(item => item.data[0].data.baseConfig.title === tabItemName);
        if (tabItemTargetComp) {
          compUnIncludeTabItems.push(tabItemTargetComp);
        }
      }

      for (let i = 0; i < unRandomTabs.length; i++) {
        // 对未重排的unRandomTabs，找到对应的pipeline-tabItem；再将pipeline-tabItem按照未重排的顺序插入到compUnIncludeTabItems中
        const tabItemName = unRandomTabs[i].tabTitle.tabName;
        const tabItemTargetComp = pipelineTabItems.find(item => item.data[0].data.baseConfig.title === tabItemName);
        if (tabItemTargetComp) {
          compUnIncludeTabItems.push(tabItemTargetComp);
        }
      }

      // 将randomTabs重新赋值给pipelineTab
      compUnIncludeTabItems[pipelineTabIdx].data.containerConfig.grains = [...randomTabs, ...unRandomTabs];

      pipelineComponents = compUnIncludeTabItems;

    } else if (group === 'Group_3') {
      
    }

  } else if (pageId === '17449786909470044') {
    // 苹果品牌馆
    const tabMapRule = {
      'Iphone': 'pipeline-tabItem-1757500906741',
      'Airpods': 'pipeline-tabItem-1757500906714',
      'Apple Watch': 'pipeline-tabItem-1757500906297',
      'Ipad': 'pipeline-tabItem-1757500906435',
      'Mac': 'pipeline-tabItem-1757500906936'
    }
    
    if (group === 'Group_3') {
      // 实验组A，iphone固定，ipods、iwatch、ipad随机打散，mac固定
      const pipelineTabIdx = pipelineComponents.findIndex(item => item.name === 'pipeline-tab');
      const pipelineTab = pipelineComponents.find(item => item.name === 'pipeline-tab');
      const pipelineTabItems = pipelineComponents.filter(item => item.name === 'pipeline-tabItem');
      const pipelineTabItemIphone = pipelineTabItems.find(item => item.id === tabMapRule['Iphone']);
      const pipelineTabItemMac = pipelineTabItems.find(item => item.id === tabMapRule['Mac']);
        
      const randomTabs = pipelineTab.data.containerConfig.grains.filter(item => ['Airpods', 'Apple Watch', 'Ipad'].includes(item.tabTitle.tabName)) || [];
      const unRandomTabs = pipelineTab.data.containerConfig.grains.filter(item => !['Airpods', 'Apple Watch', 'Ipad'].includes(item.tabTitle.tabName)) || [];

      // randomTabs进行随机排序
      for (let i = randomTabs.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = randomTabs[i];
        randomTabs[i] = randomTabs[j];
        randomTabs[j] = tmp;
      }

      // 先过滤掉所有的pipeline-tabItem
      let compUnIncludeTabItems = pipelineComponents.filter(item => item.name !== 'pipeline-tabItem');
      
      if (pipelineTabItemIphone) {
        compUnIncludeTabItems.push(pipelineTabItemIphone); 
      }
      

      for (let i = 0; i < randomTabs.length; i++) {
        // 根据重新排序后的randomTabs，找到对应的pipeline-tabItem；再将pipeline-tabItem按照重排后的顺序插入到compUnIncludeTabItems中
        const tabItemName = randomTabs[i].tabTitle.tabName;
        let tabItemTargetComp = pipelineTabItems.find(item => item.id === tabMapRule[tabItemName]);

        if (tabItemTargetComp) {
          if (tabItemName === 'Ipad') {
            // IpadPro移动至机型推荐的首位
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-imgList-1744983470639', 'pipeline-product-1744983709099'], [3, 4]);
          }

          compUnIncludeTabItems.push(tabItemTargetComp);
        }
      }

      if (pipelineTabItemMac) {
        compUnIncludeTabItems.push(pipelineTabItemMac); 
      }

      // 将randomTabs重新赋值给pipelineTab
      unRandomTabs.splice(1, 0, ...randomTabs);
      compUnIncludeTabItems[pipelineTabIdx].data.containerConfig.grains = unRandomTabs;

      pipelineComponents = compUnIncludeTabItems;

    } else if (group === 'Group_4') {
      // 将ipad固定放在Tab2，将Mac固定放在Tab3的位置
      const pipelineTabIdx = pipelineComponents.findIndex(item => item.name === 'pipeline-tab');
      const pipelineTabItemIpadIdx = pipelineComponents.findIndex(item => item.id === tabMapRule['Ipad']);
      const pipelineTabItemMacIdx = pipelineComponents.findIndex(item => item.id === tabMapRule['Mac']);
      let pipelineTab = pipelineComponents.find(item => item.name === 'pipeline-tab');
      let pipelineTabItemIpad = pipelineComponents.find(item => item.id === tabMapRule['Ipad']);
      let pipelineTabItemMac = pipelineComponents.find(item => item.id === tabMapRule['Mac']);

      // 根据tabName顺序对pipelineTab的中grains数组进行重新排序
      pipelineTab = sortGrainsByTabNameOrder(pipelineTab, ['Iphone', 'Ipad', 'Mac', 'Airpods', 'Apple Watch']);

      if (pipelineTabItemIpad) {
        // 将IpadPro移动至机型推荐的首位
        pipelineTabItemIpad = moveItemsToPositions(pipelineTabItemIpad, ['pipeline-imgList-1744983470639', 'pipeline-product-1744983709099'], [3, 4]); 
        
        // 将Ipad固定放在Tab2的位置
        pipelineComponents.splice(pipelineTabItemIpadIdx, 1);
        pipelineComponents.splice(3, 0, pipelineTabItemIpad);
      }

      if (pipelineTabItemMac) {
        // 将Mac固定放在Tab3的位置
        pipelineComponents.splice(pipelineTabItemMacIdx, 1);
        pipelineComponents.splice(4, 0, pipelineTabItemMac);
      }
      
      pipelineComponents[pipelineTabIdx] = pipelineTab;

    }
  } else if (pageId === '17470753610320084') {
    // 华为品牌馆
    const tabMapRule = {
      '手机': 'pipeline-tabItem-1750759883115',
      '穿戴': 'pipeline-tabItem-1750759883437',
      '电脑': 'pipeline-tabItem-1750759882723',
      '平板': 'pipeline-tabItem-1750759883215',
      '智慧屏': 'pipeline-tabItem-1750759882486',
      '耳机音箱': 'pipeline-tabItem-1750759883222',
    }

    if (group === 'Group_3') {
      // 实验组A，手机固定，穿戴、电脑、平板、耳机音箱随机打散，智慧屏固定
      const pipelineTabIdx = pipelineComponents.findIndex(item => item.name === 'pipeline-tab');
      const pipelineTab = pipelineComponents.find(item => item.name === 'pipeline-tab');
      const pipelineTabItems = pipelineComponents.filter(item => item.name === 'pipeline-tabItem');
      const pipelineTabItemPhone = pipelineTabItems.find(item => item.id === tabMapRule['手机']);
      const pipelineTabItemScreen = pipelineTabItems.find(item => item.id === tabMapRule['智慧屏']);
        
      const randomTabs = pipelineTab.data.containerConfig.grains.filter(item => ['穿戴', '电脑', '平板', '耳机音箱'].includes(item.tabTitle.tabName)) || [];
      const unRandomTabs = pipelineTab.data.containerConfig.grains.filter(item => !['穿戴', '电脑', '平板', '耳机音箱'].includes(item.tabTitle.tabName)) || [];

      // randomTabs进行随机排序
      for (let i = randomTabs.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = randomTabs[i];
        randomTabs[i] = randomTabs[j];
        randomTabs[j] = tmp;
      }

      // 先过滤掉所有的pipeline-tabItem
      let compUnIncludeTabItems = pipelineComponents.filter(item => item.name !== 'pipeline-tabItem');
      
      if (pipelineTabItemPhone) {
        compUnIncludeTabItems.push(pipelineTabItemPhone);
      }
      

      for (let i = 0; i < randomTabs.length; i++) {
        // 根据重新排序后的randomTabs，找到对应的pipeline-tabItem；再将pipeline-tabItem按照重排后的顺序插入到compUnIncludeTabItems中
        const tabItemName = randomTabs[i].tabTitle.tabName;
        let tabItemTargetComp = pipelineTabItems.find(item => item.id === tabMapRule[tabItemName]);

        if (tabItemTargetComp) {
          if (tabItemName === '平板') {
            // 将MatePad SE移动至机型推荐的首位
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-imgList-1750758684900', 'pipeline-product-1750758710001'], [2, 3]);
          }

          if (tabItemName === '电脑') {
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-imgList-1744984352785', 'pipeline-product-1744984374785'], [2, 3]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-imgList-1744984596807', 'pipeline-product-1744984617344'], [4, 5]);
          }

          compUnIncludeTabItems.push(tabItemTargetComp);
        }
      }

      if (pipelineTabItemScreen) {
        compUnIncludeTabItems.push(pipelineTabItemScreen);
      }

      // 将randomTabs重新赋值给pipelineTab
      unRandomTabs.splice(1, 0, ...randomTabs);
      compUnIncludeTabItems[pipelineTabIdx].data.containerConfig.grains = unRandomTabs;


      pipelineComponents = compUnIncludeTabItems;
      
    } else if (group === 'Group_4') {
      // 将平板固定放在Tab2，将电脑固定放在Tab3的位置
      const pipelineTabIdx = pipelineComponents.findIndex(item => item.name === 'pipeline-tab');
      const pipelineTabItemPadIdx = pipelineComponents.findIndex(item => item.id === tabMapRule['平板']);
      const pipelineTabItemComputerIdx = pipelineComponents.findIndex(item => item.id === tabMapRule['电脑']);
      let pipelineTab = pipelineComponents.find(item => item.name === 'pipeline-tab');
      let pipelineTabItemPad = pipelineComponents.find(item => item.id === tabMapRule['平板']);
      let pipelineTabItemComputer = pipelineComponents.find(item => item.id === tabMapRule['电脑']);

      // 根据tabName顺序对pipelineTab的中grains数组进行重新排序
      pipelineTab = sortGrainsByTabNameOrder(pipelineTab, ['手机', '平板', '电脑', '穿戴', '智慧屏', '耳机音箱']);

      if (pipelineTabItemPad) {
        // 将MatePad SE移动至机型推荐的首位
        pipelineTabItemPad = moveItemsToPositions(pipelineTabItemPad, ['pipeline-imgList-1750758684900', 'pipeline-product-1750758710001'], [2, 3]); 
        
        // 将平板固定放在Tab2的位置
        pipelineComponents.splice(pipelineTabItemPadIdx, 1);
      }

      if (pipelineTabItemComputer) {
        // MateBook GT移动至机型推荐的首位
        pipelineTabItemComputer = moveItemsToPositions(pipelineTabItemComputer, ['pipeline-imgList-1744984352785', 'pipeline-product-1744984374785'], [2, 3]); 
        // MateBook系列移动至机型推荐的第二位
        pipelineTabItemComputer = moveItemsToPositions(pipelineTabItemComputer, ['pipeline-imgList-1744984596807', 'pipeline-product-1744984617344'], [4, 5]); 
        // 将电脑固定放在Tab3的位置
        pipelineComponents.splice(pipelineTabItemComputerIdx, 1);
      }

      pipelineComponents.splice(3, 0, pipelineTabItemPad);
      pipelineComponents.splice(4, 0, pipelineTabItemComputer);

      pipelineComponents[pipelineTabIdx] = pipelineTab;
    }
  } else if (pageId === '17605154136490046') {
    // 鞋类双十一预热
    if (group === 'Group_4') {
      // 无Tab，不进行Tab随机干预
    } else if (group === 'Group_3') {
      const pipelineImageRecommendIdx = pipelineComponents.findIndex(item => item.id === 'pipeline-imgList-1760515947270');
      const pipelineImageRecommend = pipelineComponents.find(item => item.id === 'pipeline-imgList-1760515947270');
      const pipelineProductRecommend = pipelineComponents.find(item => item.id === 'pipeline-product-1760516355764');

      if (pipelineImageRecommend && pipelineProductRecommend) {
        pipelineComponents.splice(pipelineImageRecommendIdx, 2);

        pipelineComponents.push(pipelineImageRecommend);
        pipelineComponents.push(pipelineProductRecommend); 
      }
    }
  } else if (pageId === '17605920658570019') {
    // 服饰双十一会场
    const tabMapRule = {
      '男装': 'pipeline-tabItem-1760595488122',
      '女装': 'pipeline-tabItem-1760595488120'
    }
    if (group === 'Group_4') {
      const pipelineTabIdx = pipelineComponents.findIndex(item => item.name === 'pipeline-tab');
      const pipelineTab = pipelineComponents.find(item => item.name === 'pipeline-tab');
      const pipelineTabItems = pipelineComponents.filter(item => item.name === 'pipeline-tabItem');
        
      const randomTabs = pipelineTab.data.containerConfig.grains.filter(item => ['男装', '女装'].includes(item.tabTitle.tabName)) || [];
      // randomTabs进行随机排序
      for (let i = randomTabs.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = randomTabs[i];
        randomTabs[i] = randomTabs[j];
        randomTabs[j] = tmp;
      }

      let compUnIncludeTabItems = pipelineComponents.filter(item => item.name !== 'pipeline-tabItem');

      for (let i = 0; i < randomTabs.length; i++) {
        // 根据重新排序后的randomTabs，找到对应的pipeline-tabItem；再将pipeline-tabItem按照重排后的顺序插入到compUnIncludeTabItems中
        const tabItemName = randomTabs[i].tabTitle.tabName;
        let tabItemTargetComp = pipelineTabItems.find(item => item.id === tabMapRule[tabItemName]);

        if (tabItemTargetComp) {

          if (tabItemName === '男装') {
            // 热卖榜单模块顺序按：骆驼、李宁、阿迪、耐克、北面、查尔斯桃心、三叶草、乔丹的顺序固定展示
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-imgList-1698392088290'], [0]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728890023383'], [1]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728889893620'], [2]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728890178944'], [3]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1698389103164'], [4]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728890344545'], [5]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728890787900'], [6]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728890530263'], [7]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728890840236'], [8]);
          }

          if (tabItemName === '女装') {
            // 热卖榜单模块顺序按：阿迪、李宁、北面、维多利亚、lululemon、三叶草、耐克的顺序固定展示
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-imgList-1728892031374'], [0])
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728892044524'], [1]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728892057283'], [2]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728893393698'], [3]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728892041521'], [4]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728892038271'], [5]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728892048003'], [6]);
            tabItemTargetComp = moveItemsToPositions(tabItemTargetComp, ['pipeline-rank-1728892035149'], [7]);
          }

          compUnIncludeTabItems.splice(2 + i, 0, tabItemTargetComp);
        }
      }

      compUnIncludeTabItems[pipelineTabIdx].data.containerConfig.grains = randomTabs;

      pipelineComponents = compUnIncludeTabItems;

    } else if (group === 'Group_3') {

      let pipelineTabItemMan = pipelineComponents.find(item => item.id === tabMapRule['男装']);
      let pipelineTabItemWoman = pipelineComponents.find(item => item.id === tabMapRule['女装']);

      if (pipelineTabItemMan) {
        // 热卖榜单模块顺序按：骆驼、李宁、阿迪、耐克、北面、查尔斯桃心、三叶草、乔丹的顺序固定展示
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-imgList-1698392088290'], [0]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1728890023383'], [1]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1728889893620'], [2]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1728890178944'], [3]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1698389103164'], [4]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1728890344545'], [5]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1728890787900'], [6]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1728890530263'], [7]);
        pipelineTabItemMan = moveItemsToPositions(pipelineTabItemMan, ['pipeline-rank-1728890840236'], [8]);

        pipelineComponents.splice(2, 1, pipelineTabItemMan);
      }

      if (pipelineTabItemWoman) {
        // 热卖榜单模块顺序按：阿迪、李宁、北面、维多利亚、lululemon、三叶草、耐克的顺序固定展示
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-imgList-1728892031374'], [0])
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-rank-1728892044524'], [1]);
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-rank-1728892057283'], [2]);
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-rank-1728893393698'], [3]);
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-rank-1728892041521'], [4]);
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-rank-1728892038271'], [5]);
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-rank-1728892048003'], [6]);
        pipelineTabItemWoman = moveItemsToPositions(pipelineTabItemWoman, ['pipeline-rank-1728892035149'], [7]);

        pipelineComponents.splice(3, 1, pipelineTabItemWoman);
      }
    }
  }

  return pipelineComponents;
}

/**
 * 在指定的tabItem中，将指定的组件移动到指定的位置
 * @param {*} targetTabItem 目标tabItem
 * @param {*} moveCompIds 要移动的组件id数组
 * @param {*} targetPositions 目标位置数组
 * @returns 
 */
function moveItemsToPositions(targetTabItem, moveCompIds, targetPositions) {
  // 深拷贝对象
  if (!targetTabItem) {
    return targetTabItem;
  }
  const result = JSON.parse(JSON.stringify(targetTabItem));
  const dataArray = result.data;
  
  // 保存要移动的项
  const itemsToMove = [];
  
  // 按倒序找到并删除所有目标项
  moveCompIds.sort((a, b) => {
    const indexA = dataArray.findIndex(item => item.id === a);
    const indexB = dataArray.findIndex(item => item.id === b);
    return indexB - indexA; // 倒序排列，从后往前删除
  }).forEach(id => {
    const index = dataArray.findIndex(item => item.id === id);
    if (index !== -1) {
      itemsToMove.unshift(dataArray.splice(index, 1)[0]); // 保存到数组开头
    }
  });
  
  // 按指定位置插入
  targetPositions.forEach((position, index) => {
    if (itemsToMove[index]) {
      dataArray.splice(position, 0, itemsToMove[index]);
    }
  });
  
  return result;
}

/**
 * 根据传入的tabName顺序对grains数组进行重新排序
 * @param {Object} dataObj - 原始数据对象
 * @param {Array} tabNameOrder - tabName的顺序数组，如：['Iphone', 'Airpods', 'Apple Watch', 'Ipad', 'Mac']
 * @returns {Object} - 返回排序后的新对象（不修改原对象）
 */
function sortGrainsByTabNameOrder(dataObj, tabNameOrder) {
  // 深拷贝原对象，避免修改原数据
  const result = JSON.parse(JSON.stringify(dataObj));
  
  // 获取grains数组
  const grains = result.data.containerConfig.grains;
  
  // 创建tabName到索引的映射，用于快速查找
  const tabNameToIndex = {};
  tabNameOrder.forEach((tabName, index) => {
    tabNameToIndex[tabName] = index;
  });
  
  // 对grains数组进行排序
  grains.sort((a, b) => {
    const tabNameA = a.tabTitle.tabName;
    const tabNameB = b.tabTitle.tabName;
    
    const indexA = tabNameToIndex[tabNameA];
    const indexB = tabNameToIndex[tabNameB];
    
    // 如果tabName在顺序数组中不存在，则排在最后
    if (indexA === undefined && indexB === undefined) return 0;
    if (indexA === undefined) return 1;
    if (indexB === undefined) return -1;
    
    return indexA - indexB;
  });
  
  return result;
}



// WEBPACK FOOTER //
// ./utils/interveneTest.js